module.exports = __webpack_public_path__ + "img/Honigloeffel-v2-300.8ddd7748.png";